import React from 'react'
import ReactMarkdown from 'react-markdown'
const Git = () => {
  return (
     <img
            className="ht1"
            id="github-streak-stats"
            src="https://github-readme-streak-stats.herokuapp.com/?user=UmaSahni"
          />
  )
}

export default Git